/** Permite solo <strong> / <b> en copy CMS de alianzas (Figma). */
export function sanitizeAlianzaHtml(raw: string | null | undefined): string {
  const text = String(raw ?? '');
  if (!text) {
    return '';
  }
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return escaped
    .replace(/&lt;(\/?)\s*(strong|b)\s*&gt;/gi, '<$1strong>');
}
